define("Pages/DoNotSellMyInfo", [`Page`, `module`], function (Super, Self) {
	return Super.inherit({
		namespace: Self.id,
		requires: [`XHR`, `Country`],
		defaults: {
			render: true,
		},
		prepare(setup) {
			const { data } = this;

			data.title = `Do Not Sell My Info | Tixr`;
		},
		constructor() {
			const { Config, data, instances } = this;
			const { trackingOptions } = data;
			const { COUNTRY_OPTIONS } = Config;

			trackingOptions.pageType = `DoNotSellMyInfo`;

			this.create({
				namespace: `Modules/PageHeader`,
				setup: {
					name: `page-header`,
					showTixrLogo: true,
				},
				done: true,
			});

			this.create({
				namespace: `Modules/PageFooter`,
				setup: {
					name: `page-footer`,
				},
			});

			this.create({
				namespace: `Widgets/Form`,
				setup: {
					name: `form`,
					theme: `NONE`,
					inputs: {
						hasAccount: {
							type: `NativeDropdown`,
							rules: {
								label: `Do you have a Tixr account?`,
								options: [
									{ label: `Yes, I have a Tixr account`, value: `true` },
									{ label: `No, I don't have a Tixr account`, value: `false` },
								],
								errorMessage: `Value required`,
								trim: true,
							},
							validation: {
								type: `String`,
								required: true,
							},
						},
						firstName: {
							type: `Textbox`,
							rules: {
								label: `First Name`,
								errorMessage: `First Name is required`,
								trim: true,
							},
							validation: {
								type: `String`,
								required: true,
							},
						},
						lastName: {
							type: `Textbox`,
							rules: {
								label: `Last Name`,
								errorMessage: `Last Name is required`,
								trim: true,
							},
							validation: {
								type: `String`,
								required: true,
							},
						},
						email: {
							type: `Textbox`,
							rules: {
								label: `Email`,
								tooltip: `e.g. myemail@example.com`,
								errorMessage: `Please enter a valid e-mail`,
								trim: true,
							},
							validation: {
								type: `String`,
								required: true,
								max_length: 50,
								pattern: Config.REGEX.email,
							},
						},
						countryCodeAlpha2: {
							type: `NativeDropdown`,
							rules: {
								label: `Country`,
								icon: `earth`,
								options: COUNTRY_OPTIONS,
								errorMessage: `Country is required`,
							},
							validation: {
								type: `String`,
								required: true,
							},
						},
						state: {
							type: `Textbox`,
							rules: {
								label: `State/Province`,
								errorMessage: `State/Province is required`,
								trim: true,
							},
							validation: {
								type: `String`,
								required: true,
							},
						},
						postalCode: {
							type: `Textbox`,
							rules: {
								label: `ZIP/Postal Code`,
								errorMessage: `ZIP/Postal Code is required`,
								trim: true,
							},
							validation: {
								type: `String`,
								required: true,
								pattern: `^[a-zA-Z0-9.][a-zA-Z0-9. -]{0,24}$`,
							},
						},
						comments: {
							type: `Textbox`,
							rules: {
								label: `Comments (Optional)`,
								trim: true,
							},
						},
					},
					callbacks: {
						update: (value, key, inputs) => {
							if (instances.form) {
								const submitButtonEl = this.select(`[action="submit"]`);
								instances.form.validate()
									? submitButtonEl.removeClass(`disabled`)
									: submitButtonEl.addClass(`disabled`);
							}
						},
						submit: function (values, inputs) {
							values.force = false;

							this.submit({
								request: values,
							});
						},
					},
				},
			});
		},
		api: {
			submit: {
				async: true,
				value(options) {
					const { App } = this;
					const { request } = options;
					return this.XHR.ajax({
						type: `POST`,
						url: `/api/user/do-not-sell-my-info`,
						REST: true,
						data: request,
						then: () => {
							App.notifyUser({
								type: `success`,
								message: `Successful request, we will no longer sell or share your info`,
							});
						},
						fail: (error) => {
							const message =
								error && error.message
									? error.message
									: `Something went wrong, please try again or call the number below`;

							App.notifyUser({
								type: `error`,
								message,
							});
						},
					});
				},
			},
		},
	});
});

define("Pages/DoNotSellMyInfo.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Pages/DoNotSellMyInfo/main"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<header class=\"head\"> <div name=\"page-header\"></div> <div class=\"scroll-head-background\"></div> </header> <main class=\"body\"> <div class=\"background\"> <div class=\"image\"></div> </div> <div class=\"content main vp-min-height\"> <h2> Do Not Sell or Share My Info Request Portal </h2> <div class=\"description\"> <p> You have the right to opt out of the sale or sharing of your personal information which will also opt you out of targeted advertising and profiling. To opt out of sales or sharing, please <strong>use the form below</strong> or call us at <a href=\"tel:+1855-315-1625\">+1 (855) 315-1625</a>. </p> <p> For more information about how we handle your personal information, including how to exercise any other privacy rights, please review our <a href=\"/privacy\" target=\"_blank\">Privacy Policy</a>. </p> </div> <div name=\"form\"> <div name=\"hasAccount\"></div> <div name=\"email\"></div> <div name=\"firstName\"></div> <div name=\"lastName\"></div> <div name=\"state\"></div> <div name=\"postalCode\"></div> <div name=\"countryCodeAlpha2\"></div> <div name=\"comments\"></div> <div name=\"sell\"></div> <a href=\"#\" class=\"button\" action=\"submit\" theme=\"BLUE\"> <p>Submit</p> </a> </div> </div> <div class=\"content footer\"> <div name=\"page-footer\"></div> </div> </main>";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=DoNotSellMyInfo.js.map